import { erpAxios } from '..';

const editAnalysis = async (data) => {
  const res = await erpAxios.post(`/analiza/edit`, data);
  return res;
};

export default editAnalysis;
